import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import Axios from "axios";

import globalContext from "../../Hooks/globalContext";
import PageWrapper from "../../Components/Common/PageWrapper";
import Loader from "../../Components/Common/Loader";
import useState from "../../Hooks/useState";
import { HOST } from "../../Utils/constants";
import { dateConvertor, numberWithCommas } from "../../Utils/util";
import languagePack from "../../Utils/language";

const PAGE_UNIT = 5;

const Thumbnail = styled.img`
  width: 100%;
  max-width: 720px;
  margin-bottom: 5px;
`;

const ProductWrapper = styled.div`
  padding: 10px;
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: white;
  margin-bottom: 10px;
  box-sizing: border-box;
  cursor: pointer;
  :hover {
    opacity: 0.75;
  }
`;

const TopLabelWrapper = styled.div`
  padding: 20px;
`;

const TopLabel = styled.div`
  text-align: center;
  font-size: 15px;
  color: ${(props) => props.theme.darkGrey};
`;

const ProductInfo = styled.div`
  margin-bottom: 5px;
  padding: 0px 5px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ProductTitle = styled.div`
  font-weight: bold;
  color: ${(props) => props.theme.black};
  font-size: 15px;
`;

const ProductDate = styled.div`
  color: ${(props) => props.theme.darkGrey};
`;

const ProductPrice = styled.div`
  font-weight: bold;
  font-size: 15px;
`;

const MoreButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 15px;
  color: ${(props) => props.theme.darkGrey};
  font-size: 17px;
  cursor: pointer;
  :hover {
    opacity: 0.75;
  }
`;

const Product = ({ item, history }) => {
  const onClick = () => {
    history.push(`/market/${item.id}`);
  };
  const uri = `${HOST}/${item.image}`;
  return (
    <ProductWrapper onClick={onClick}>
      <Thumbnail resizeMode="contain" src={uri} />
      <ProductInfo>
        <ProductTitle>{item.title}</ProductTitle>
      </ProductInfo>
      <ProductInfo>
        <ProductDate>{dateConvertor(new Date(item.created_at), "summary")}</ProductDate>
        <ProductPrice>{numberWithCommas(item.price_krw) + "₩"}</ProductPrice>
      </ProductInfo>
    </ProductWrapper>
  );
};

const Page = ({ history }) => {
  const { user, language, balance, modal, sendEth, sendToken, web3, httpHeader } = useContext(globalContext);
  const page = useState(0);
  const list = useState(null);
  const more = useState(false);

  const moreOnClick = async () => {
    more.setState(true);
    const next = page.state + 1;
    const requestBody = {
      page: next,
      unit: PAGE_UNIT,
    };
    page.setState(next);
    const { data } = await Axios.post(`${HOST}/market/list`, requestBody, httpHeader());
    const concat = list.state.select.concat(data.select);

    list.setState({ count: data.count, select: concat });

    more.setState(false);
  };

  const preload = () => {
    const init = async () => {
      const requestBody = {
        page: page.state,
        unit: PAGE_UNIT,
      };
      const { data } = await Axios.post(`${HOST}/market/list`, requestBody, httpHeader());

      list.setState(data);
    };
    init();
  };

  useEffect(preload, []);
  return (
    <PageWrapper>
      {list.state ? (
        list.state.count === 0 ? (
          <TopLabelWrapper>
            <TopLabel>{languagePack("등록된 상품이 없습니다.", language.state)}</TopLabel>
          </TopLabelWrapper>
        ) : (
          <>
            {list.state.select.map((item, index) => {
              return <Product key={index} item={item} history={history} />;
            })}

            {list.state.select.length < list.state.count &&
              (more.state ? (
                <MoreButton>
                  <Loader size={15} color="grey" fit={true} />
                </MoreButton>
              ) : (
                <MoreButton onClick={moreOnClick}>{languagePack("더 보기", language.state)}</MoreButton>
              ))}
          </>
        )
      ) : (
        <Loader size={15} color="grey" />
      )}
    </PageWrapper>
  );
};

export default Page;
